import { Box, Flex, FlexProps, Heading } from "@biblioteksentralen/react";
import { ReactNode } from "react";

export const Meta = ({ label, children, ...flexProps }: FlexProps & { label: string; children: ReactNode }) => (
  <Flex align="flex-start" {...flexProps}>
    <Heading as="h2" fontSize="md" minWidth="5rem" marginRight="1rem">
      {label}
    </Heading>
    <Box maxWidth={{ base: "unset", md: "14rem" }} _firstLetter={{ textTransform: "uppercase" }}>
      {children}
    </Box>
  </Flex>
);
